module.exports = __webpack_public_path__ + "img/highmast_on.fc5dee17.svg";